import React from "react";
import ReactDOM from "react-dom/client"; // ✅ updated import
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root')); // ✅ use createRoot
root.render(
  <React.StrictMode>
  <App />
  </React.StrictMode>
);

reportWebVitals();
